/**
 * What: The existing successful comparison-image upload reply, validated at each boundary.
 * Transport / data-flow: Web storage endpoint -> Shopify relay -> browser. Pure schema; no I/O.
 */
import * as z from 'zod';
export const shopifyMediaUploadResponseSchema = z.object({
    status: z.literal('uploaded'),
    id: z.string().min(1),
    key: z.string().min(1),
    mediaUrl: z.url(),
});
/** One stable builder field; the server chooses storage and binds this destination into its receipt. */
export const shopifyMediaUploadGrantRequestSchema = z.strictObject({
    draftId: z.string().min(1).max(200),
    studyId: z.string().min(1).max(200).optional(),
    key: z.string().regex(/^comparisons\.[a-zA-Z0-9_-]+\.options\.[a-zA-Z0-9_-]+$/),
    fileName: z.string().min(1).max(255),
    contentType: z.string().min(1).max(100),
    size: z.number().int().positive().max(Number.MAX_SAFE_INTEGER),
});
export const shopifyMediaUploadGrantResponseSchema = z.strictObject({
    uploadUrl: z.url(),
    requiredHeaders: z.record(z.string(), z.string()),
    expiresAt: z.iso.datetime(),
    receipt: z.string().min(1),
});
export const shopifyMediaUploadFinalizeRequestSchema = z.strictObject({ receipt: z.string().min(1).max(8192) });
export const SHOPIFY_MEDIA_UPLOAD_GRANT_OPERATION = {
    id: 'media-upload.grant',
    method: 'POST',
    path: '/api/media-uploads/grant',
    requestSchema: shopifyMediaUploadGrantRequestSchema,
    responseSchema: shopifyMediaUploadGrantResponseSchema,
    auth: { merchant: true, operator: true, requiresOfflineToken: false, merchantOnlyGates: [] },
    effects: [{ kind: 'external-fetch', description: 'Authorize one scoped conditional direct R2 upload through Web' }],
    risk: { cost: 'free', destructive: false, dryRunCapable: false },
    idempotent: false,
};
export const SHOPIFY_MEDIA_UPLOAD_FINALIZE_OPERATION = {
    id: 'media-upload.finalize',
    method: 'POST',
    path: '/api/media-uploads/finalize',
    requestSchema: shopifyMediaUploadFinalizeRequestSchema,
    responseSchema: shopifyMediaUploadResponseSchema,
    auth: { merchant: true, operator: true, requiresOfflineToken: false, merchantOnlyGates: [] },
    effects: [
        { kind: 'external-fetch', description: 'Verify scoped R2 object and register canonical media through Web' },
        { kind: 'd1-write', description: 'Register one accepted org-scoped media row' },
    ],
    risk: { cost: 'free', destructive: false, dryRunCapable: false },
    idempotent: false,
};
//# sourceMappingURL=shopify-media-upload.js.map